import { EditDecorationPage } from 'src/pages/_myAccount/EditDecoration'

export const EditDecorationPageOpen = () => {
  return (
    <div className="bg-gray-100">
      <EditDecorationPage />
    </div>
  )
}
